import React, { useEffect, useState } from "react";
import "./blogList.css";
import { toast } from "react-toastify";
import { collection, getDocs, limit, orderBy, query, startAfter, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import blogIcons from './../../blogIcon';
import BlogCategory from "../Category/category";
import { db } from "../../../../Config/Firebase/config";

const BlogList = () => {
  
  const [blogData, setBlogData] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [isChecked, setIsChecked] = useState(true);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const navigate = useNavigate();

  const detailBlog = (blogData) => {
    navigate(`/blog/${blogData.id}`);
  }

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setCategoryId('');
  };

  useEffect(() => {
    const blogDataCollectionRef = collection(db, "blogdata");
    const getBlogData = async () => {
      try{
        let q;
        if(categoryId !== ''){
          q = query(
            blogDataCollectionRef, 
            where("category.id", "==",categoryId), 
            orderBy("createdAt",'desc'), 
            limit(3)
          );
        }else{
          q = query(
            blogDataCollectionRef,
            orderBy("createdAt", 'desc'), 
            limit(3)
          );
        }
        const data = await getDocs(q);
        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setBlogData(filteredData);
        setShowLoadMore(true);
        if(categoryId !== ''){
          setIsChecked(false);
        }
      }catch(error){
        toast.error("Could not Load Blog Data");
      }
    }
    getBlogData();
  }, [categoryId]);

   const loadMoreBlogs = async (e) => {
    e.preventDefault();
    try {
      const blogDataCollectionRef = collection(db, "blogdata");
      const lastDoc= blogData[blogData.length - 1];
      let q;
      if(categoryId !== ''){
       q = query(
        blogDataCollectionRef, 
        where("category.id", "==", categoryId), 
        orderBy("createdAt",'desc'), 
        startAfter(lastDoc.createdAt), 
        limit(3)
      );
      }else{
        q = query(
          blogDataCollectionRef, 
          orderBy("createdAt",'desc'), 
          startAfter(lastDoc.createdAt), 
          limit(3)
        );
      }
      const data = await getDocs(q);
      const newBlogData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      if(newBlogData.length === 0){
        setShowLoadMore(false);
      }
      setBlogData(prevBlogData => [...prevBlogData, ...newBlogData]);
    } catch (error) {
      toast.error("Could not Load More Blog Data");
    }
  }

  return (
      <React.Fragment>
        <section className="bloglist section">
          <div className="bloglist-container">
            <div className="row">
              <div className="section-title padd-15">
                <h2>Santalum Designs Blog({blogData.length})</h2>
              </div>
            </div>

            {!isChecked && <div className="checkbox-container padd-15">
              <label className="cancel-text">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className="checkbox-input"
                />
                <span className="checkbox-custom"></span>
              </label>
              <p className="cancel-text">Remove Filter</p>
            </div>}

            <div className="bloglist-content">
              <div className="row">
                {
                  blogData.length !== 0 ? blogData.map((data) => (
                    <div className="bloglist-item padd-15" key={data.id}>
                      <div className="bloglist-item-inner">
                        <div className="top-section">
                          <div className="category-time">
                            <p className="category-icon">{blogIcons.categoryIcon}</p>
                            <p className="category">{data.category['title']}</p>
                            <p className="timeRead">{data.timeRead}</p>
                          </div>
                          <div className="date">{data.date}</div>
                        </div>
                        <h3 className="item-title">{data.title}</h3>
                        <p className="item-summary">{data.summary}</p>
                        <div className="readmore-btn" onClick={() => detailBlog(data)}>Read More</div>
                      </div>
                    </div>
                  )) : <h3>No Article Found</h3>
                }
              </div>
            </div>
            {showLoadMore && <div className="loadmore-button">
              <h3 onClick={loadMoreBlogs}>Load More</h3>
            </div>}
          </div>
        </section>
        <BlogCategory
          setBlogData = {setBlogData}
          setCategoryId = {setCategoryId}
          categoryId= {categoryId}
        />
      </React.Fragment>
  );
};

export default BlogList;
